module.exports = __webpack_public_path__ + "img/il_logo.49cfd2b6.jpg";